import { ProductEntity } from '@/entities/product.entity';
import { FC } from 'react';

export type ProductCellProps = {
    product: ProductEntity;
};

const ProductCell: FC<ProductCellProps> = ({ product }) => {
    const productSku = product.sku.trim();
    const productName = product.name.trim();

    return (
        <p className="line-clamp-2 break-words">
            {productSku && <span className="text-xs text-black/50">{productSku}</span>}
            {productSku && productName && ' '}
            {productName}
        </p>
    );
};

export default ProductCell;
